import type { FunctionComponent } from 'react';
import { memo } from 'react';
import { Article } from '../../components/article';
import { Box } from '../../components/box';
import { Breadcrumbs } from '../../components/breadcrumbs';
import { Section } from '../../components/layout/section';
import { SectionOfContent } from '../section-of-content';
export const PageLoadingState: FunctionComponent = memo(() => <>
        <SectionOfContent background={{
    label: 'step-white'
  }} loading />
        <SectionOfContent background={{
    label: 'step-cyanora'
  }} loading />
        <SectionOfContent background={{
    label: 'step-white'
  }} loading />
        <SectionOfContent background={{
    label: 'step-midnight'
  }} loading />
    </>);
export const ArticlePageLoadingState: FunctionComponent = /*#__PURE__*/() => <>
        <Section data-sentry-element="Section" data-sentry-source-file="index.tsx">
            <Box pad={['vertical']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
                <Breadcrumbs loading current='' links={[]} data-sentry-element="Breadcrumbs" data-sentry-source-file="index.tsx" />
            </Box>
        </Section>
        <Section data-sentry-element="Section" data-sentry-source-file="index.tsx">
            <Article loading data-sentry-element="Article" data-sentry-source-file="index.tsx" />
        </Section>
    </>;